import React, {useEffect, useState} from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PdfDocument from '../PDF/pdfDocument.js';
import {toPng} from 'html-to-image';

const GeneratePdf = ({leadData, rowData}) => {

    const [chartImage, setChartImage] = useState()
    const {main_lead, merchant_name} = rowData;
    const title = `${main_lead}_${merchant_name} audit-details.pdf`

    useEffect(() => {
        const handleGenerateChartImage = async () => {
            const node = document.getElementById('pdf-gauge-chart');

            const dataUrl = await toPng(node);
            setChartImage(dataUrl);
        };

        handleGenerateChartImage();
    }, [leadData]);

    return (
        <div className="p-0">
            <PDFDownloadLink
                document={<PdfDocument leadData={leadData} rowData={rowData} chartImage={chartImage}/>}
                fileName={title}
            >
                {({ loading }) => (
                    <i
                        className="ri-download-2-line text-primary"
                        style={{ fontSize: "19px", cursor: 'pointer' }}
                    >
                    </i>
                )}
            </PDFDownloadLink>
        </div>
    );
};

export default GeneratePdf;
